<!--
 * @Description: 自动打印排号
 * @Author: zml
 * @Date: 2023-04-28 12:27:44
 * @LastEditors: pcc
 * @LastEditTime: 2023-10-21 09:50:13
-->
<template>
  <div class="print">
    <div class="title">自动打印排号</div>
    <div class="search">
      <el-form ref="ruleForm" :inline="true" :model="queryParam" class="demo-form-inline">
        <el-form-item label="厂商编号:" prop="ma_Na">
          <el-input
            style="width: 4rem;"
            ref="input"
            v-model="queryParam.ma_Nu"
            placeholder="厂商编号"
            @keydown.enter.native="onPrint"
            @blur="onblur"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="background: #1890ff;color:#fff" @click="onPrint" :loading="loading">打印（按厂商编号）</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="display:none">
      <span id="errorMsg">请输入厂商编号</span>
    </div>
  </div>
</template>

<script>
import {
  GetManufacturerInfo,
  getExhibitionCode,
  decryptingQRcode,
  printARowNumber,
  getHallWorkReport,
  getHallWorkErrorReport,
  saveHallWorkReport,
  saveHallWorkErrorReport,
  reportPrintFile,
  deletePrintCache,
  decryptingHSQRcode
} from '@/api/home'
import { mapState } from 'vuex'
import moment from 'moment'
var socketTimer = null
export default {
  data() {
    return {
      loading: false,
      isFocus: false,
      path: 'ws://127.0.0.1:11999',
      socket: "",
      printLoading: null,
      time: 60,
      // 查询参数
      queryParam: {
        ma_Nu: ''
      },
      printCode: '',
      exhibitionCode: ''
    }
  },
  computed: {
    ...mapState('tenant', ['tenantInfo'])
  },
  created() {
    this.initData()
  },
  mounted() {
    this.$refs.input.focus()
    this.init()
    window.addEventListener('click', () => {
      this.time = 60
    })
  },
  destroyed() {
    window.removeEventListener('click', () => { })
    this.socket.onclose = () => { console.log('socket已经关闭') }
  },
  methods: {
    // 初始化socket
    init() {
      if (typeof (WebSocket) === 'undefined') {
        this.$message.warning('您的浏览器不支持socket，将无法使用打印功能')
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.path)
        this.socket.onopen = this.open
        this.socket.onerror = this.error
        this.socket.onmessage = this.getMessage
      }
    },

    // 连接socket
    open() {
      this.$message.success('打印服务连接成功')
      // 心跳检测
      this.heartCheck()
    },
    // 连接错误
    error() {
      const _this = this

      // 清除心跳检测
      if (socketTimer) {
        clearInterval(socketTimer)
      }

      if (this.printLoading) {
        this.printLoading.close()
      }

      setTimeout(() => {
        _this.init()
      }, 5000)
    },

    // 监听消息
    getMessage(res) {
      if (res.data === 'ok' && this.printLoading) {
        this.printLoading.close()
        deletePrintCache({ code: this.printCode })
      } else if (res.data !== 'ok' && res.data.indexOf('Version') === -1) {
        this.$message.warning(res.data)
        this.printLoading.close()
      }
    },

    // socket心跳检测
    heartCheck() {
      if (socketTimer) {
        clearInterval(socketTimer)
      }

      const _this = this
      socketTimer = setInterval(() => {
        if (_this.socket.readyState !== 1) {
          _this.init()
        }
      }, 3000)
    },

    initData() {
      getExhibitionCode().then(res => {
        if (res.success) {
          this.exhibitionCode = res.data || ''
        } else {
          this.$message.error(JSON.stringify(res.message))
        }
      })
    },
    // 聚焦
    onblur() {
      if (!this.isFocus) {
        this.isFocus = true
        setTimeout(() => {
          this.isFocus = false
          this.$refs.input.focus()
        }, 10000)
      }
    },

    // 打印
    async onPrint() {
      // 校验厂商编号是否输入
      if (!this.queryParam.ma_Nu) {
        this.$message.warning('请选输入厂商编号')
        this.$refs.input.focus()
        return
      }

      if (this.socket.readyState !== 1) {
        this.$message.warning('打印服务未启动，请联系展厅工作人员')
        return
      }

      const reportResult = await getHallWorkErrorReport()
      // 大于20个字符(校验是否是小竹熊识别到的二维码)
      if (this.queryParam.ma_Nu.length > 20 && this.queryParam.ma_Nu.indexOf('hsrj') === -1) {
        const result = await decryptingQRcode({ code: decodeURIComponent(this.queryParam.ma_Nu) })
        if (result.success) {
          const strArr = result.data.split(';')
          // 判断展厅识别码
          if (this.exhibitionCode !== strArr[5]) {
            this.queryParam.ma_Nu = ''
            this.$message.error('该二维码不是当前展厅，请出示当前展厅的厂商二维码')
            var printResult = await saveHallWorkErrorReport({ reportId: reportResult.data, errorMsg: '请出示当前展厅的厂商二维码' })
            this.printData(printResult.data)
            this.$refs.input.focus()
            return
          }

          // 判断二维码有效期
          const qrCodeTime = moment(strArr[1])
          const systemTime = moment()
          if (qrCodeTime.isBefore(systemTime)) {
            this.queryParam.ma_Nu = ''
            this.$message.error('二维码已失效，请出示有效的二维码')
            var printResult = await saveHallWorkErrorReport({ reportId: reportResult.data, errorMsg: '二维码已失效，请重新刷新' })
            this.printData(printResult.data)
            this.$refs.input.focus()
            return
          }

          this.queryParam.ma_Nu = strArr[3]
        } else {
          this.queryParam.ma_Nu = ''
          this.$message.error(JSON.stringify(result.message))
          this.$refs.input.focus()
          return
        }
      }

      if(this.queryParam.ma_Nu.indexOf('hsrj')>-1){
        const code = this.queryParam.ma_Nu.substring(this.queryParam.ma_Nu.indexOf('hsrj') + 4)
        const result = await decryptingHSQRcode({ code: code })
        if (result.success) {
          const strArr = result.data.split(',')
          // 判断展厅识别码
          if (this.tenantInfo.id != strArr[1]) {
            this.queryParam.ma_Nu = ''
            this.$message.error('该二维码不是当前展厅，请出示当前展厅的厂商二维码')
            this.$refs.ma_Nu.focus()
            return
          }

          // 判断二维码有效期
          const qrCodeTime = moment(strArr[2])
          const systemTime = moment()
          if (qrCodeTime.isBefore(systemTime)) {
            this.queryParam.ma_Nu = ''
            this.$message.error('二维码已失效，请出示有效的二维码')
            this.$refs.ma_Nu.focus()
            return
          }

          this.queryParam.ma_Nu = strArr[0]
        } else {
          this.queryParam.ma_Nu = ''
          this.$message.error(JSON.stringify(result.message))
          this.$refs.input.focus()
          return
        }
      }

      // 判断是否公开见客（非公开见客临时厂商，要走厂商校验）
      
      if (this.queryParam.ma_Nu.indexOf('OT_') === -1) {
        // 获取厂商信息
        const manufacturer = await GetManufacturerInfo({ ma_Nu: this.queryParam.ma_Nu })
        if (!manufacturer.success || !manufacturer.data) {
          this.queryParam.ma_Nu = ''
          this.$message.error(manufacturer.message)
          var printResult = await saveHallWorkErrorReport({ reportId: reportResult.data, errorMsg: manufacturer.message })
          this.printData(printResult.data)
          this.$refs.input.focus()
          return
        } else {
          this.queryParam.ma_Nu = manufacturer.data.ma_Nu
        }
      }

      let ma_Nu = this.queryParam.ma_Nu
      // 获取报表
      const report = await getHallWorkReport()
      if (!report.success) {
        this.queryParam.ma_Nu = ''
        this.$message.warning('暂未设置打印报表，请联系展厅工作人员')
        return
      }

      // 获取厂商排号信息
      const rowNumberData = await printARowNumber({ ma_Nu })
      if (!rowNumberData.success || rowNumberData.data.length === 0) {
        this.queryParam.ma_Nu = ''
        this.$message.warning('当前厂商暂无排号信息，无法打印')
        var printResult = await saveHallWorkErrorReport({ reportId: reportResult.data, errorMsg: '对不起！当前没有您的排号' })
        this.printData(printResult.data)
        return
      }

      // 保存报表参数
      const saveReport = await saveHallWorkReport({ dataIds: rowNumberData.data, reportId: report.data })
      if (!saveReport.success) {
        this.queryParam.ma_Nu = ''
        this.$message.warning(JSON.stringify(saveReport.message))
        return
      }

      this.printLoading = this.$loading({
        lock: true,
        text: '正在生成文件，请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.queryParam.ma_Nu = ''
      this.printData(saveReport.data)
    },
    printData(data) {
      // 打印Pdf
      reportPrintFile({ code: data, tenantId: this.tenantInfo.id }).then(res => {
        if (res.success) {
          this.printCode = data
          const objData = {
            type: 0,
            message: res.data
          }
          this.socket.send(JSON.stringify(objData))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.print {
  height: 100vh;
  font-family: MicrosoftYaHei;
  .title {
    text-align: center;
    padding: 0.2rem;
    font-size: 0.3rem;
    font-weight: bold;
    border: 0.01rem solid #eee;
  }

  .search {
    display: flex;
    align-items: center;
    min-height: 1.1rem;
    // height: 10%;
    padding: 0 0.3rem;

    .el-form {
      display: flex;
      width: 100%;
    }

    :deep .el-form-item {
      display: flex;
      align-items: center;
      margin: 0 0.2rem 0 0;

      .el-form-item {
        display: flex;
        align-items: center;
      }

      .el-form-item__label {
        font-size: 0.18rem !important;
        color: #222222;
      }

      .el-input__inner {
        font-size: 0.18rem !important;
        height: 0.4rem !important;
        line-height: 0.4rem !important;
        color: #8a8a8a;
      }
      button {
        height: 0.4rem !important;
        line-height: 0.4rem;
        padding: 0 0.06rem;
        font-size: 0.18rem !important;
        width: 1rem;
        color: #848484;
        width: 2rem;
      }
    }
  }
}
</style>